import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isValueEntered } from 'services/Validation';
import { ISSUE_TYPES } from 'constants/lists';
import { ISSUE_TYPE_RELEASE } from 'constants/project';
import { formatDateDefault, DEFAULT_DATE_FORMAT } from 'services/DateFormatters';
import moment from 'moment';
import { isDateBefore } from 'services/DateService';

export const inputFields = (data, features, members, handleUserInput, handleDateInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className={`form-control mb-2 ${data?.description ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading">{<IntlMessages id="label.type" />}</h3>
                <Input
                    type="select"
                    name="type"
                    id="type"
                    className={data?.type ? 'is-valid' : 'is-invalid'}
                    onChange={(event) => handleUserInput(event)}
                    value={data?.type}
                >
                    <option key='emptySelect' value=''>-- select issue type --</option>
                    {ISSUE_TYPES.map((type) => {
                        return <option key={type} value={type}>{type}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.feature" />}</h3>
                <Input
                    type="select"
                    name="featureId"
                    id="feature"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.featureId}
                >
                    <option key='emptySelect' value=''>-- select feature --</option>
                    {features.map((feature) => {
                        return <option key={feature.id} value={feature.id}>{feature.name}</option>;
                    })}
                </Input>

                <h3 className="card-heading mt-2">{<IntlMessages id="label.assignee" />}</h3>
                <Input
                    type="select"
                    name="assigneeId"
                    id="assignee"
                    onChange={(event) => handleUserInput(event)}
                    value={data?.assigneeId}
                >
                    <option key='emptySelect' value=''>-- select assignee --</option>
                    {members.map((assignee) => {
                        return <option key={assignee.id} value={assignee.id}>{assignee.name}</option>;
                    })}
                </Input>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.startDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="startDate"
                        value={formatDateDefault(data?.startDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('startDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.startDate),
                        }}
                    />
                </div>
                <h3 className="card-heading mt-2">{<IntlMessages id="label.endDate" />}</h3>
                <div className="form-control">
                    <DayPickerInput
                        id="endDate"
                        value={formatDateDefault(data?.endDate)}
                        placeholder={DEFAULT_DATE_FORMAT}
                        onDayChange={(selectedDay) => handleDateInput('endDate', selectedDay)}
                        dayPickerProps={{
                            selectedDays: new Date(data?.endDate),
                        }}
                    />
                </div>
                {data?.type === ISSUE_TYPE_RELEASE
                    ?
                    <Fragment>
                        <h3 className="card-heading mt-2">{<IntlMessages id="label.releaseEnv" />}</h3>
                        <Input id="releaseEnv" type="text" className={`form-control mb-2 ${data?.releaseEnv ? 'is-valid' : 'is-invalid'}`}
                            onChange={(event) => handleUserInput(event)}
                            defaultValue={data?.releaseEnv} name="releaseEnv"
                        />

                        <h3 className="card-heading mt-2">{<IntlMessages id="label.releaseDate" />}</h3>
                        <div className={`form-control ${data?.releaseDate ? 'is-valid' : 'is-invalid'}`}>
                            <DayPickerInput
                                id="releaseDate"
                                value={formatDateDefault(data?.releaseDate)}
                                placeholder={DEFAULT_DATE_FORMAT}
                                onDayChange={(selectedDay) => handleDateInput('releaseDate', selectedDay)}
                                dayPickerProps={{
                                    selectedDays: new Date(data?.releaseDate),
                                }}
                            />
                        </div>
                        <h3 className="card-heading mt-2">{<IntlMessages id="label.releaseCutoffDate" />}</h3>
                        <div className="form-control">
                            <DayPickerInput
                                id="releaseCutoffDate"
                                value={formatDateDefault(data?.releaseCutoffDate)}
                                placeholder={DEFAULT_DATE_FORMAT}
                                onDayChange={(selectedDay) => handleDateInput('releaseCutoffDate', selectedDay)}
                                dayPickerProps={{
                                    selectedDays: new Date(data?.releaseCutoffDate),
                                }}
                            />
                        </div>

                        <h3 className="card-heading mt-2">{<IntlMessages id="label.releaseVersion" />}</h3>
                        <Input id="releaseVersion" type="text" className={`form-control mb-2 ${data?.releaseVersion ? 'is-valid' : 'is-invalid'}`}
                            onChange={(event) => handleUserInput(event)}
                            defaultValue={data?.releaseVersion} name="releaseVersion"
                        />

                    </Fragment>
                    : null
                }
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedIssue) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedIssue?.thumb || 'assets/images/issues-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const isFormValid = (selectedIssue) => {
    let valid = isValueEntered(selectedIssue?.name) &&
        isValueEntered(selectedIssue?.description) &&
        isValueEntered(selectedIssue?.type);
    if (selectedIssue?.type === ISSUE_TYPE_RELEASE) {
        valid = valid &&
        isValueEntered(selectedIssue?.releaseDate) &&
        isValueEntered(selectedIssue?.releaseEnv) &&
        isValueEntered(selectedIssue?.releaseVersion);
    }
    return valid;
};

export const getFormError = (fieldName, value, selectedIssue) => {
    let formError = '';
    switch (fieldName) {
        case 'name':
        case 'description':
        case 'type':
            formError = isValueEntered(value) ? '' : ' is invalid';
            break;
        case 'releaseEnv':
        case 'releaseDate':
        case 'releaseVersion':
            if (selectedIssue?.type === ISSUE_TYPE_RELEASE) {
                formError = isValueEntered(value) ? '' : ' is invalid';
            }
            break;
        default:
            break;
    }
    return formError;
};

export const checkDatesValid = (selectedIssue) => {
    // console.log('checkDatesValid start');
    if (isValueEntered(selectedIssue?.endDate) && isValueEntered(selectedIssue?.startDate)) {
        // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
        if (isDateBefore(moment(selectedIssue?.endDate), moment(selectedIssue?.startDate))) {
            // console.log('checkDatesValid start ERRORS');
            return false;
        }
        // console.log('checkDatesValid start ALL GOOD');
        return true;
    }
    if (selectedIssue?.type === ISSUE_TYPE_RELEASE) {
        if (isValueEntered(selectedIssue?.releaseDate) && isValueEntered(selectedIssue?.releaseCutoffDate)) {
            // DayPickerInput gives a format that DateService does not like so utilise moment as the default before passing to the date check
            if (isDateBefore(moment(selectedIssue?.releaseDate), moment(selectedIssue?.releaseCutoffDate))) {
                // console.log('checkDatesValid start ERRORS');
                return false;
            }
            // console.log('checkDatesValid start ALL GOOD');
            return true;
        }
    }
    return true; // mandatory dates are checked in getFormError
};


// WEBPACK FOOTER //
// ./components/Agile/issue/issueMaintenance/common.js